/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { QueryService } from './services/query.service';
import { HealthService } from './services/health.service';
import { PublicService } from './services/public.service';
import { CustomerDetailsService } from './services/customer-details.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    QueryService,
    HealthService,
    PublicService,
    CustomerDetailsService,
    ApiConfiguration
  ],
})
export class CustomerReadModelModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomerReadModelModule> {
    return {
      ngModule: CustomerReadModelModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomerReadModelModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomerReadModelModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
